import { createVanIconComponent } from "./van"

const Music = createVanIconComponent("music")
export default Music
